/* @flow */

import type { RootState, Action, Vector } from '../types'

export const STATE_KEY = 'pollBuilderExpertOpinionCreateHelper'

export const SET_EXPERT_OPINION_CREATE_HELPER =
  'opinary/SET_EXPERT_OPINION_CREATE_HELPER'

export function setExpertOpinionCreateHelper(value: ?Vector): Action {
  return {
    type: SET_EXPERT_OPINION_CREATE_HELPER,
    value,
  }
}

export function selectExpertOpinionCreateHelper(state: RootState): ?Vector {
  return state[STATE_KEY]
}

export default function reducer(state: ?Vector = null, action: Action) {
  switch (action.type) {
    case SET_EXPERT_OPINION_CREATE_HELPER:
      return action.value || null
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/stores/pollBuilderExpertOpinionCreateHelper.js